module.exports = __webpack_public_path__ + "static/media/fbtb_header.d5c9395e.png";